import { render, staticRenderFns } from "./CampaignPromotersCard.vue?vue&type=template&id=665e7cc6&scoped=true&"
import script from "./CampaignPromotersCard.vue?vue&type=script&lang=js&"
export * from "./CampaignPromotersCard.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPromotersCard.vue?vue&type=style&index=0&id=665e7cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e7cc6",
  null
  
)

export default component.exports